import React, { useState } from "react";
import "../styles/StudentSurvey.scss";

const StudentSurvey = ({ questions = [], onChange, onComplete }) => {
  const [answers, setAnswers] = useState({});

  const handleSelectOption = (sequence, value) => {
    const updated = { ...answers, [sequence]: value };
    setAnswers(updated);
    if (onChange) onChange(updated);
  };

  const handleInputChange = (sequence, value) => {
    const updated = { ...answers, [sequence]: value };
    setAnswers(updated);
    if (onChange) onChange(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onComplete) onComplete(answers);
  };

  const allAnswered = questions.every((q) => {
    const value = answers[q.sequence];
    if (value === undefined || value === null) return false;
    if (q.type === "fillups") {
      return String(value).trim() !== "";
    }
    return String(value).trim() !== "";
  });

  return (
    <>
      <form className="student-survey" onSubmit={handleSubmit}>
        {questions.map((q, index) => (
          <div key={q.id ?? q.sequence} className="survey-question-card">
            <div className="survey-question-text">
              {index + 1}
              {" . "}
              {q.question}
            </div>

            {q.examples && (
              <div className="survey-examples">
                <span className="label">Example</span>
                <span>{q.examples}</span>
              </div>
            )}

            {q.type === "mcq" && Array.isArray(q.options) && (
              <div className="survey-options">
                {q.options.map((opt) => (
                  <label key={opt} className="survey-option">
                    <input
                      type="radio"
                      name={`q-${q.sequence}`}
                      value={opt}
                      checked={answers[q.sequence] === opt}
                      onChange={() => handleSelectOption(q.sequence, opt)}
                    />
                    <span>{opt}</span>
                  </label>
                ))}
              </div>
            )}

            {q.type === "fillups" && (
              <textarea
                className="survey-input"
                value={answers[q.sequence] || ""}
                onChange={(e) => handleInputChange(q.sequence, e.target.value)}
                placeholder="Type your answer here"
              />
            )}
          </div>
        ))}

        {questions.length > 0 && (
          <div className="survey-actions">
            <button
              type="submit"
              className="survey-submit-btn"
              disabled={!allAnswered}
            >
              Submit
            </button>
          </div>
        )}
      </form>
    </>
  );
};

export default StudentSurvey;
